import React from "react";
import { person } from "../../../components/defaultHeader/assets";
import colors from "../../../utils/colors";
import Button from "../../../components/ui/button";
import Modal from "../../../components/ui/modal";
import { TAppointmentDetails } from "../../../types";

interface IProps {
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  appointment: TAppointmentDetails;
}

const AppointmentDetailsModal = ({
  isOpen,
  onClose,
  title,
  appointment,
}: IProps) => {
  return (
    <Modal isOpen={isOpen} onClose={() => onClose(false)} title={title}>
      <div className="mt-6 flex flex-col gap-6 px-4 text-sm break-words">
        {/* Patient name */}
        <div className="flex items-center gap-2 flex-wrap">
          <img
            src={person}
            alt="Patient"
            className="w-8 h-8 object-cover rounded-full"
          />
          <p className="text-base">{appointment["Patient Name"]}</p>
        </div>

        {/* Date & Time */}
        <div className="flex flex-col md:flex-row gap-4">
          <div className="w-full md:w-1/2">
            <p className="mb-1 text-gray-500">Date</p>
            <p style={{ color: colors.dark }}>{appointment["Date"]}</p>
          </div>
          <div className="w-full md:w-1/2">
            <p className="mb-1 text-gray-500">Time</p>
            <p style={{ color: colors.dark }}>{appointment["Time"]}</p>
          </div>
        </div>

        {/* Category & Mode */}
        <div className="flex flex-col md:flex-row gap-4">
          <div className="w-full md:w-1/2">
            <p className="mb-1 text-gray-500">Category</p>
            <Button
              text={appointment["Appointment Category"]}
              theme="primary"
              size="xs"
              className="!rounded-[20px] w-fit px-3 py-1 max-w-full truncate"
            />
          </div>
          <div className="w-full md:w-1/2">
            <p className="mb-1 text-gray-500">Mode</p>
            <Button
              text={appointment["Appointment Mode"]}
              theme="primary"
              size="xs"
              className="!rounded-[20px] w-fit px-3 py-1 max-w-full truncate"
            />
          </div>
        </div>

        {/* Status & Note */}
        <div className="flex flex-col md:flex-row gap-4">
          <div className="w-full md:w-1/2">
            <p className="mb-1 text-gray-500">Appointment Status</p>
            <Button
              text={appointment["Appointment Status"]}
              theme="primary"
              size="xs"
              className="!rounded-[20px] w-fit px-3 py-1 max-w-full truncate"
            />
          </div>
          <div className="w-full md:w-1/2">
            <p className="mb-1 text-gray-500">Note</p>
            <p style={{ color: colors.dark }}>{appointment["Note"]}</p>
          </div>
        </div>
        {/* Status & Note */}
        <div className="flex flex-col md:flex-row gap-4">
          <div className="w-full md:w-1/2">
            <p className="mb-1 text-gray-500">Appointment Address</p>
            <p style={{ color: colors.dark }}>
              {appointment["Appointment Address"]}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AppointmentDetailsModal;
